module.exports = __webpack_public_path__ + "static/media/es.4b40d197.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/buttonCulture/es.png
// module id = 447
// module chunks = 0